import * as React from 'react';

import UnifiedAppCheckContext from 'bundles/unified-common/contexts/UnifiedAppCheckContext';

/**
 * @description Every unified app page will update this context value to be 'true'.
 */
const UnifiedAppCheckProvider = ({ children }: { children: React.ReactNode }) => {
  return <UnifiedAppCheckContext.Provider value={true}>{children}</UnifiedAppCheckContext.Provider>;
};

export default UnifiedAppCheckProvider;
